import React from 'react'
import TableCellDesktop from './TableCellDesktop'

const TableCellTitre = ({
  children,
  ...others
}) => {
  return (
    <TableCellDesktop
      data-testid="carte-titre"
      style={{
        paddingLeft: 0,
        paddingRight: 0
      }}
      {...others}
    >
      {children}
    </TableCellDesktop>
  )
}

export default TableCellTitre
